// extracted by mini-css-extract-plugin
export var standaloneTable = "_hs-0";
export var standaloneTableWithBodyFill = "_hs-1";
export var withExtraHeader = "_hs-2";